import {
  CardNameLiteral,
  CardTypeLiteral,
  GaugeSetting,
} from '../../types/apiResponse/tankInfoSettingTypes'
import { TankType } from '../../types/apiResponse/tankSpecTypes'
import { patchData, putData } from '../../utils'
import { useTankInfoStageStore } from '../../store/tankInfo/useTankInfoStageStore'

/**
 * @deprecated This endpoint has been removed from backend V2
 */
export const patchToggleSetting = async (_body: { [card in CardNameLiteral]?: boolean }) => {
  console.warn('patchToggleSetting is deprecated: tank-info-setting endpoint no longer exists')
}

/**
 * @deprecated This endpoint has been removed from backend V2
 */
export const putGaugeSetting = async (_body: GaugeSetting, _detailSettingId: string) => {
  console.warn('putGaugeSetting is deprecated: tank-info-card-detail endpoint no longer exists')
}

/**
 * @deprecated This endpoint has been removed from backend V2
 */
export const putCardTypeSetting = async (_cardType: CardTypeLiteral, _detailSettingId: string) => {
  console.warn('putCardTypeSetting is deprecated: tank-info-card-detail endpoint no longer exists')
}

/**
 * Update tank specifications
 * Note: Check swagger for the correct endpoint format
 */
export const putTankSpec = async (tankSpec: TankType, tankId: string) => {
  await putData(`tank/${tankId}`, tankSpec)
}

export const totalSettingMutation = async (tankId: string) => {
  const {
    gaugeSettings,
    toggleSettings,
    typeSettings,
    tank,
    detailSettingIds,
    addCallbackQueryKeys,
  } = useTankInfoStageStore.getState()
  let isSettingMutated = false
  for (const entry of Object.entries(gaugeSettings)) {
    if (entry[1] === undefined) continue
    await putGaugeSetting(entry[1], detailSettingIds[entry[0] as CardNameLiteral] as string)
    isSettingMutated = true
  }
  for (const entry of Object.entries(typeSettings)) {
    if (entry[1] === undefined) continue
    await putCardTypeSetting(entry[1], detailSettingIds[entry[0] as CardNameLiteral] as string)
    isSettingMutated = true
  }
  // Merge changed toggles with initial settings to send complete state
  const { initialSettings } = useTankInfoStageStore.getState()
  const mergedToggleSettings: { [card in CardNameLiteral]?: boolean } = {}

  // Start with initial settings
  if (initialSettings.toggleSettings) {
    Object.entries(initialSettings.toggleSettings).forEach(([key, value]) => {
      mergedToggleSettings[key as CardNameLiteral] = value as boolean
    })
  }

  // Override with changed values (excluding undefined)
  for (const [key, value] of Object.entries(toggleSettings)) {
    if (value !== undefined) {
      mergedToggleSettings[key as CardNameLiteral] = value as boolean
    }
  }

  if (Object.keys(mergedToggleSettings).length > 0) {
    await patchToggleSetting(mergedToggleSettings)
    addCallbackQueryKeys(['tankInfo', 'toggle'])
  }
  if (isSettingMutated) {
    addCallbackQueryKeys(['tankInfo', 'detail', 'Water'])
    addCallbackQueryKeys(['tankInfo', 'detail', 'Fish'])
    addCallbackQueryKeys(['tankInfo', 'detail', 'Tank'])
  }

  if (tank !== undefined) {
    await putTankSpec(tank, tankId)
    addCallbackQueryKeys(['tankInfo', 'detail', 'Tank'])
    addCallbackQueryKeys(['tankInfo', 'value', tankId, 'tankVolume'])
  }
}
